import {
    FETCH_PCS_WEIGHT_REQUEST,
    FETCH_PCS_WEIGHT_SUCCESS,
    FETCH_PCS_WEIGHT_FAILURE,
    CREATE_PCS_WEIGHT_FORM,
    UPDATE_PCS_WEIGHT_FORM,
    CREATE_PCS_WEIGHT_SUCCESS,
    FETCH_SINGLE_PCS_WEIGHT_SUCCESS,
    UPDATE_PCS_WEIGHT_SUCCESS,
    DELETE_PCS_WEIGHT_SUCCESS,
    CREATE_PCS_WEIGHT_REQUEST,
    UPDATE_PCS_WEIGHT_REQUEST,
    FETCH_SINGLE_PCS_WEIGHT_REQUEST,
    DELETE_PCS_WEIGHT_REQUEST,
    RESET_PCS_WEIGHT_INFO,
    CREATE_PCS_WEIGHT_FAILURE,
    UPDATE_PCS_WEIGHT_FAILURE,
    FETCH_SINGLE_PCS_WEIGHT_FAILURE,
    DELETE_PCS_WEIGHT_FAILURE,
    FETCH_PROGRAM_MAPPING_BY_NAME_SUCCESS,
    FETCH_PROGRAM_MAPPING_BY_NAME_REQUEST,
    FETCH_PROGRAM_MAPPING_BY_NAME_FAILURE,
    FETCH_PCS_WEIGHT_PART_DETAIL_INFO_REQUEST,
    FETCH_PCS_WEIGHT_PART_DETAIL_INFO_SUCCESS,
    FETCH_PCS_WEIGHT_PART_DETAIL_INFO_FAILURE,
    FETCH_PCS_WEIGHT_PART_COLOR_SUCCESS,
    FETCH_PCS_WEIGHT_PART_COLOR_REQUEST,
    FETCH_PCS_WEIGHT_PART_COLOR_FAILURE,
    FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_REQUEST,
    FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_FAILURE,
    FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_SUCCESS,
    FORCE_RENDER_DELETE_UPDATE
} from './pcsWeight.actionsType';

export const PCS_WEIGHT = 'pcsWeight';

let initialState = {
    loading: false,
    pcsWeightList: [],
    pcsWeightListDummy: [],
    pcsWeightPartColor: [],
    pcsWeightStylePartDetailInfo: [],
    programMappingListByName: [],
    pcsWeightForm: {},
    selectedState: {},
    errorMessage: '',
    forceRender: false
};

export let pcsWeightReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_PCS_WEIGHT_REQUEST:
        case CREATE_PCS_WEIGHT_REQUEST:
        case UPDATE_PCS_WEIGHT_REQUEST:
        case FETCH_SINGLE_PCS_WEIGHT_REQUEST:
        case FETCH_PROGRAM_MAPPING_BY_NAME_REQUEST:
        case DELETE_PCS_WEIGHT_REQUEST:
        case FETCH_PCS_WEIGHT_PART_DETAIL_INFO_REQUEST:
        case FETCH_PCS_WEIGHT_PART_COLOR_REQUEST:
        case FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightList: updatePayload,
                pcsWeightListDummy: updatePayload

            };
        case FETCH_PCS_WEIGHT_PART_DETAIL_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightStylePartDetailInfo: updatePayload
            };
        // pcsWeightList: state.pcsWeightList.map((object, i) => {
        //     return (object['tblStylePrepPartMasterId'] = updatePayload[i]?.tblStylePrepPartMasterId);
        // })
        case FETCH_PCS_WEIGHT_PART_COLOR_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightPartColor: updatePayload
            };
        case FORCE_RENDER_DELETE_UPDATE: {
            return {
                ...state,
                loading: false,
                pcsWeightForm: {},
                forceRender: true
            }
        }
        case FETCH_PROGRAM_MAPPING_BY_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingListByName: updatePayload
            };
        case CREATE_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: {}
            };
        case FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                previousSelectedColor: updatePayload
            }
        case UPDATE_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: {}
            };
        case FETCH_SINGLE_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: updatePayload
            };
        case DELETE_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: {},
                forceRender: false
            };
        case RESET_PCS_WEIGHT_INFO:
            return {
                ...state,
                pcsWeightForm: {},
                pcsWeightList: [],
                pcsWeightStylePartDetailInfo: []
                // pcsWeightPartColor: []
            };
        case DELETE_PCS_WEIGHT_FAILURE:
            return {
                ...state,
                loading: false,
                forceRender: false
            }
        case CREATE_PCS_WEIGHT_FORM:
        case UPDATE_PCS_WEIGHT_FORM:
            return {
                ...state,
                loading: false,
                pcsWeightForm: {
                    ...state.pcsWeightForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PCS_WEIGHT_FAILURE:
        case CREATE_PCS_WEIGHT_FAILURE:
        case UPDATE_PCS_WEIGHT_FAILURE:
        case FETCH_SINGLE_PCS_WEIGHT_FAILURE:
        case FETCH_PROGRAM_MAPPING_BY_NAME_FAILURE:
        case FETCH_PCS_WEIGHT_PART_DETAIL_INFO_FAILURE:
        case FETCH_PCS_WEIGHT_PART_COLOR_FAILURE:
        case FETCH_PCS_WEIGHT_PREV_COLOR_PART_DETAIL_INFO_FAILURE:
            return {
                ...state,
                loading: false,
                forceRender: false
            };
        default:
            return state;
    }
};
